import {jsonSafeStorage} from '@github-ui/safe-storage'
import {useMemo} from 'react'

/**
 * Hook for caching data in localStorage with feature flag control
 * @param cacheKey - The key to use for storing in localStorage
 * @returns Object with cachedValue and updateCache functions
 */
export function useLocalStorageCache<T>(cacheKey: string) {
  const safeLocalStorage = jsonSafeStorage<T>('localStorage')

  const value: T | undefined = useMemo(() => {
    return safeLocalStorage.getItem(cacheKey) ?? undefined
  }, [safeLocalStorage, cacheKey])

  const setValue = (updated_value: T) => {
    safeLocalStorage.setItem(cacheKey, updated_value)
  }

  const removeItem = () => {
    safeLocalStorage.removeItem(cacheKey)
  }

  return {value, setValue, removeItem}
}
